import {intlShape, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import {find, pick} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './RadioButton.less';
import RadioButtonItem from './RadioButtonItem';
import {I18N as I18NTextBox} from './TextBox';
import stylesAutoLayout from '../AutoLayout.less';
import AutoLayoutRenderer from 'src/js/lib/auto_layout/auto_layout_renderer';
import AutoLayoutService from 'src/js/lib/auto_layout/auto_layout_service';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {LayoutProperty} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';
import {KEYWORD_PROP_CONTENT_VALUE} from 'src/js/model/auto_layout_screen_data_helpers';

class RadioButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {options: this.getOptions()};

    this.handleChange = this.handleChange.bind(this);
    this.isChecked = this.isChecked.bind(this);
  }

  handleChange(e) {
    const {onDataChange} = this.props;
    onDataChange(this.getOnDataChangeData(e.target.value));
  }

  getOnDataChangeData(newData) {
    const {label} = this.props;
    const {options} = this.state;
    let newDataOption = null;
    if (newData) {
      newDataOption = find(options, (option) => option.id === newData);
    }
    return {
      ...pick(this.props, ['pathToData', 'data']),
      label,
      newData: {[KEYWORD_PROP_CONTENT_VALUE]: newDataOption},
    };
  }

  getOptions() {
    const {content, inputName, metadata} = this.props;
    return AutoLayoutRenderer.getSelectOptions(
      metadata.getContent(),
      content,
      inputName
    );
  }

  getTextOnlyValue() {
    const {data, intl} = this.props;
    return data &&
      data[KEYWORD_PROP_CONTENT_VALUE] &&
      data[KEYWORD_PROP_CONTENT_VALUE] !== ''
      ? utils.TranslateUtils.translate(
          {
            id:
              data[KEYWORD_PROP_CONTENT_VALUE].label ||
              data[KEYWORD_PROP_CONTENT_VALUE],
          },
          intl
        )
      : utils.TranslateUtils.translate(I18NTextBox.EMPTY_DATA, intl);
  }

  isChecked(item) {
    const {data} = this.props;
    const selectedItem = data[KEYWORD_PROP_CONTENT_VALUE];
    return (selectedItem && item && selectedItem.id === item.id) || false;
  }

  render() {
    const {hasError, idSuffix, inputName, isReadOnly, isTextOnly, screenId} =
      this.props;
    const {options} = this.state;
    const textOnlyValue = this.getTextOnlyValue();
    const radioButtonGroupName = `${screenId}_${inputName}`;
    return isTextOnly ? (
      <span
        className={stylesAutoLayout.dlScreenComponentInput}
        title={textOnlyValue}
      >
        {textOnlyValue}
      </span>
    ) : (
      <div
        className={classNames(
          styles.dlRadioButtonInput,
          stylesAutoLayout.dlScreenComponentInput,
          {[styles.dlValidationError]: hasError}
        )}
        name={radioButtonGroupName}
        id={AutoLayoutService.getComponentId(screenId, inputName, idSuffix)}
      >
        {options.map((item) => (
          <RadioButtonItem
            key={item.id}
            value={item.id}
            disabled={isReadOnly}
            checked={this.isChecked(item)}
            label={item.label}
            name={radioButtonGroupName}
            onChange={this.handleChange}
          />
        ))}
      </div>
    );
  }
}

RadioButton.displayName = 'RadioButton';

/* eslint-disable react/no-unused-prop-types */
RadioButton.propTypes = {
  content: PropTypes.instanceOf(ContentProperty).isRequired,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  isReadOnly: PropTypes.bool,
  isTextOnly: PropTypes.bool,
  inputName: PropTypes.string,
  intl: intlShape.isRequired,
  label: PropTypes.string,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
};

RadioButton.defaultProps = {
  data: {},
  idSuffix: '',
  pathToData: '',
  isReadOnly: false,
  isTextOnly: false,
  inputName: '',
  label: '',
  expanded: false,
  hasError: false,
};

export default injectIntl(RadioButton);
